import React from "react";
import useMediaQuery from "../../hooks/useMediaQuery";
import GuestListDesktop from "./GuestListDesktop";
import GuestListMobile from "./GuestListMobile";

const GuestList = ({ guests, onEdit, onDelete }) => {

    const isMobile = useMediaQuery("(max-width: 768px)");

    if (isMobile) {
        return (
            <GuestListMobile
                guests={guests}
                onEdit={onEdit}
                onDelete={onDelete}
            />
        );
    }

    return (
        <GuestListDesktop
            guests={guests}
            onEdit={onEdit}
            onDelete={onDelete}
        />
    );
};

export default GuestList;
